import { useAtom } from "@mdotm/shadcn/legacy/reactivity";
import { useCallback } from "react";
import { customerDecimalPlaces, user$ } from "$root/functional-areas/user";
import { userRepository } from "$root/functional-areas/user/repository";
import { makeTaskQueue } from "$root/utils/task-queue";
import { seconds } from "$root/utils";
import { sleep } from "@mdotm/shadcn/legacy/utils";

export const countDecimalPlaces = (value: number): number => {
	if (!Number.isFinite(value)) {
		return 0;
	}
	const [, fraction = ""] = Math.abs(value).toString().split(".");
	return fraction.length;
};

// queue of size 1 -> last enqueued callback wins
const userSyncQueue = makeTaskQueue(1);

export function useDecimalPlaces(): {
	userDecimalPlacesPreferences: number | undefined;
	customerDecimalPlacesPreferences: number;
	handlePrecisionChange: (newValue: number) => void;
} {
	const [user, setUser] = useAtom(user$);

	const debouncedSyncDecimalPlaces = useCallback(
		(decimalPlaces: number | undefined) => {
			userSyncQueue.enqueue(async () => {
				// decimalPlaces is the API field name behind userDecimalPlacesPreferences
				await userRepository.patchUser(user.id, { decimalPlaces });
				// debounces the task queue
				await sleep(seconds(0.3));
			});
		},
		[user.id],
	);

	const handlePrecisionChange = useCallback(
		(newValue: number) => {
			setUser((latestUser) => ({ ...latestUser, userDecimalPlacesPreferences: newValue }));
			debouncedSyncDecimalPlaces(newValue);
		},
		[debouncedSyncDecimalPlaces, setUser],
	);

	return {
		userDecimalPlacesPreferences: user.userDecimalPlacesPreferences,
		customerDecimalPlacesPreferences: customerDecimalPlaces(user),
		handlePrecisionChange,
	};
}
